// export const API_URL = "http://127.0.0.1:8000/api/";
export const API_URL = "https://api.superszcrm.com/api/";

